import React, { useState, useEffect } from 'react'
import { 
  useSelector, 
  useDispatch 
} from 'react-redux'
import * as actions from 'data/redux/actions'
import numeral from 'numeral'

import { useUser } from './use-user'

export const useGames = () => {

  const dispatch = useDispatch()
  const { userId } = useUser()
  const games = useSelector(state => state?.games)

  useEffect(() => {

    dispatch(actions.getGames(userId))
    
  }, [])

  return {
    games: games
  }
}
